import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  reviewTag: [],
  restaurantReviewList: {
    data: [],
    offset: 0,
    limit: 10,
    total: 0,
    isLoading: false,
    hasMore: true
  }
};

export default function reviewReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOAD_REVIEW_TAG:
    case actionTypes.LOAD_REVIEW_TAG_FAIL: {
      return {
        ...state,
        reviewTag: INITIAL_STATE.reviewTag
      };
    }
    case actionTypes.LOAD_REVIEW_TAG_SUCCESS: {
      return {
        ...state,
        reviewTag: action.data
      };
    }

    case actionTypes.LOAD_RESTAURANT_REVIEW: {
      let restaurantReviewList = cloneDeep(state.restaurantReviewList);
      restaurantReviewList.offset = action.data.offset;
      restaurantReviewList.limit = action.data.limit;
      restaurantReviewList.isLoading = true;
      restaurantReviewList.hasMore = false;

      // offset 0 then clear data
      if (restaurantReviewList.offset === 0) {
        restaurantReviewList.data = [];
      }

      return {
        ...state,
        restaurantReviewList
      };
    }
    case actionTypes.LOAD_RESTAURANT_REVIEW_SUCCESS: {
      let restaurantReviewList = cloneDeep(state.restaurantReviewList);
      restaurantReviewList.data = [
        ...restaurantReviewList.data,
        ...action.data.review_data
      ];
      restaurantReviewList.total = action.data.total_review;
      restaurantReviewList.isLoading = false;
      restaurantReviewList.hasMore = true;

      if (
        restaurantReviewList.data.length === 0 ||
        action.data.review_data.length < restaurantReviewList.limit
      ) {
        restaurantReviewList.hasMore = false;
      }

      return {
        ...state,
        restaurantReviewList
      };
    }

    case actionTypes.LOAD_RESTAURANT_REVIEW_FAIL: {
      return {
        ...state,
        restaurantReview: INITIAL_STATE.restaurantReview
      };
    }
    default:
      return state;
  }
}
